import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Purpose } from '../models/purpose';

@Injectable()
export class PurposeService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  public getAll(): Promise<Purpose[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Purpose[]>(environment.apiUrl + 'PurposeofExamination/getall').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<Purpose> {
    return new Promise((resolve, reject) => {
      this.http.get<Purpose>(environment.apiUrl + 'PurposeofExamination/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public save(purpose: Purpose): Promise<Purpose> {
    return new Promise((resolve, reject) => {
      if (purpose.is_edit) {
        this.http.put<Purpose>(environment.apiUrl + 'PurposeofExamination/put', purpose).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated purpose');
        }, error => {
          ////console.log(error);
          reject();
        });
      } else {
        this.http.post<Purpose>(environment.apiUrl + 'PurposeofExamination/post', purpose).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added purpose');
        }, error => {
          ////console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string): Promise<PagedData<Purpose>> {
    const pagedData = new PagedData<Purpose>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;

      this.http.get<ServerData>(environment.apiUrl + 'PurposeofExamination/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
